import { render } from "./SettingsIcon.vue?vue&type=template&id=049f892c"
const script = {}

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__